<script>
import axios from '@/utils/axios';
import { allUsers } from '@/utils/user';

export default {
inject: ['setLoading'],  
 data() {
   return {
    errors: {}, 
    id: '',
    users: [],
    user_id: '',
    sources: [],
    source_id: '',
    priority: 1,
    weight: '',
    daily_capacity: 0, 
   };
 },
 methods: {

  async getUsers(){
   try{
    const response = await allUsers();
    this.users = response.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }
  },

  async getSources(){
   try{
    const response = await axios.get(`/lead-sources`);
    this.sources = response.data.data;
   }catch(error){
    this.$swalToast(error.message, 'error');
   }
  },

  rule(row = null){
   this.getUsers(); 
   this.resetForm();
   this.getSources();
   if(row !== null){
    this.id = row.id;
    this.user_id = row.user_id;
    this.source_id = row.source_id;
    this.priority = row.priority;
    this.daily_capacity = row.daily_capacity;
   }
  },

  async saveRule(){
   this.errors = {};
   this.setLoading(true); 
   try{
    const payload = {
     id: this.id,
     user_id: this.user_id,
     source_id: this.source_id,
     priority: this.priority,
     daily_capacity: this.daily_capacity
    }; 
    let response = []; 
    if(this.id){
    //UPDATE
     response = await axios.put(`/lead-assignment-rules/${this.id}/update`, payload);
    }else{
    //CREATE
     response = await axios.post(`/lead-assignment-rules/create`, payload);
    }
    this.$swalToast(response.data.message);
    this.$emit('updated'); 
    this.$closeModal('assignment_rule_modal');
    this.resetForm();
   }catch(error){
    if(error.type == 'validation'){
     this.errors = error.errors;
    }else{
     this.$swalToast(error.message, 'error');
    }
   }finally{
    this.setLoading(false); 
   }
  },

  async deleteRule(){
   this.setLoading(true);
   try{
    const response = await axios.delete(`/lead-assignment-rules/${this.id}/delete`);
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.$closeModal('delete_modal');
   }catch(error){
    this.$swalToast(error.message, 'error');
    this.$closeModal('delete_modal');
   }finally{
    this.setLoading(false);
   }
  }, 

  resetForm() { 
   this.id = null;
   this.errors = {};
   this.user_id = '';
   this.source_id = '';
   this.daily_capacity = 0;
  },

  },
};
</script>

<template>
<!-- Add -->
<div class="modal fade" id="assignment_rule_modal">
<div class="modal-dialog modal-dialog-centered modal-mg w-100">
<div class="modal-content">
<div class="modal-header">
 <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} Assignment Rule</h4>
 <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
  <i class="ti ti-x"></i>
 </button>
</div>
<form @submit.prevent="saveRule">
<div class="modal-body pb-0">
<div class="row">

 <div class="col-6 mb-3">
  <label class="form-label fw-semibold">Source <i class="ti ti-info-circle me-2" title="Auto-Assignment only applicable for IndiaMART, TradeIndia, ExportersIndia, JustDial"></i><span class="text-danger">*</span></label>
  <vue-select :options="sources" label="name" placeholder="Source" :reduce="s => s.id" v-model="source_id" />
  <div v-if="errors.source_id" class="text-danger small mt-1">{{ errors.source_id[0] }}</div>
 </div>

 <div class="col-6 mb-3">
  <label class="form-label fw-semibold">User<span class="text-danger">*</span></label>
  <vue-select :options="users" label="name" placeholder="User" :reduce="u => u.id" v-model="user_id" />
  <div v-if="errors.user_id" class="text-danger small mt-1">{{ errors.user_id[0] }}</div>
 </div> 

 <!-- <div class="col-6 mb-2">
  <label class="form-label fw-semibold">Priority <i class="ti ti-info-circle me-2" title="'WHO GETS FIRST' (lower number = higher priority)"></i><span class="text-danger">*</span></label>
  <input type="number" class="form-control" v-model="priority" min="1" />
  <div v-if="errors.priority" class="text-danger small mt-1">{{ errors.priority[0] }}</div>
 </div>
   -->

    <div class="col-6 mb-2">
  <label class="form-label fw-semibold">Daily Capacity <i class="ti ti-info-circle me-2" title="'WHO CAN ACCEPT MORE' (higher limit = more leads/day)"></i>
     <span class="text-muted fw-normal" style="font-size: 11px;">(0-100%)</span>
    <span class="text-danger">*</span></label>
  <input type="number" class="form-control" v-model="daily_capacity" min="1" />
  <div v-if="errors.daily_capacity" class="text-danger small mt-1">{{ errors.daily_capacity[0] }}</div>
 </div>


</div>
</div>
<div class="modal-footer">
<button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
<button type="submit" class="btn btn-primary">Save</button>
</div>
</form>
</div>
</div>
</div>
<!-- /Add -->

<!-- Delete Modal -->
<div class="modal fade" id="delete_modal">
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content">
<div class="modal-body text-center">
  <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
    <i class="ti ti-trash-x fs-36"></i>
  </span>
  <h4 class="mb-1">Confirm Delete</h4>
  <p class="mb-3">
    You want to delete the item, this cant be undone once you delete.
  </p>
  <div class="d-flex justify-content-center">
    <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
    <a href="javascript:void(0);" class="btn btn-danger" @click="deleteRule">Yes, Delete</a>
  </div>
</div>
</div>
</div>
</div>
<!-- /Delete Modal -->
</template>
